module.exports = __webpack_public_path__ + "img/FGr_FK_Führungs_und_Kommunikationstrupp.a4d9f363.svg";